import React from 'react';
import useFileDownload from 'modules/file_manager/hooks/useFileDownload';
import GlobalTooltip from 'components/GlobalTooltip';

const GenericFileDownload = ({ file, iconClassName = 'icon-save text-primary-main', onDownloadComplete }) => {
  const { downloadFile } = useFileDownload();

  const handleDownload = async () => {
    if (!file) return;

    await downloadFile(file, onDownloadComplete);
  };

  if (!file) return null;

  return (
    <span role="button" onClick={handleDownload}>
      <GlobalTooltip tooltip="Download" className="float-end text-primary-main" position="bottom">
        <i className={iconClassName} aria-hidden="true" />
      </GlobalTooltip>
    </span>
  );
};

export default GenericFileDownload;
